export function saveData(data) {
  localStorage.setItem('data', JSON.stringify(data));
}
